import { Component, Injector, OnInit, AfterViewInit } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppAuthService } from '@app/shared/common/auth/app-auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AbpModule } from 'abp-ng2-module';
import { UtilsModule } from '@shared/utils/utils.module';
import { RouterModule } from '@angular/router';
@Component({
    selector: 'app-anonymoususer.checkout.cancel',
    templateUrl: './anonymoususer.checkout.cancel.component.html',
    animations: [appModuleAnimation()],
    standalone: true,
    imports: [FormsModule, NgbModule, UtilsModule, AbpModule, CommonModule, RouterModule]
})
export class AnonymousUserCheckOutCancelComponent extends AppComponentBase implements OnInit, AfterViewInit {
    constructor(injector: Injector, private _authService: AppAuthService) {
        super(injector);
    }
    ngOnInit(): void {
    }
    ngAfterViewInit() {
        $('#aContinueToHomepage').on('click', (e) => {
            this._authService.logout();
        });
    }
}
